export default __webpack_public_path__ + "static/r-pitch-2-5115951c59ef3359c7f0d0da9bca26f1.jpg";